import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
      setTimeout(() => setAnimate(true), 50); // slide up
    }
  }, []);

  const closeBanner = (value) => {
    localStorage.setItem("cookieConsent", value);
    setAnimate(false); // slide down
    setTimeout(() => setVisible(false), 300); // wait animation
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 w-full z-[9999]
        transform transition-all duration-300 ease-out
        ${animate ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}
      `}
    >
      <div className="bg-gradient-to-t from-gray-300 via-gray-100 to-white border-t shadow-2xl">

        <div
          className="max-w-7xl mx-auto px-6 py-4
          flex flex-col lg:flex-row
          items-start lg:items-center
          justify-between gap-4"
        >
          {/* Text */}
          <p className="text-sm text-gray-700 leading-relaxed max-w-4xl">
            Welcome to <span className="font-semibold">Hirees</span>! We use cookies
            to improve your experience, analyze traffic, and personalize content.
            Learn more in our{" "}
            <Link
              to="/cookie-policy"
              className="text-blue-600 font-medium hover:underline"
            >
              Cookies Policy
            </Link>{" "}
            and{" "}
            <Link
              to="/privacy-policy"
              className="text-blue-600 font-medium hover:underline"
            >
              Privacy Statement
            </Link>.
          </p>

          {/* Actions */}
          <div className="flex items-center gap-4 whitespace-nowrap">
            {/* <button className="text-sm font-semibold text-gray-700 underline hover:text-black">
              Cookie Settings
            </button> */}

            <button
              onClick={() => closeBanner("rejected")}
              className="px-5 py-2 text-sm font-semibold
              border border-blue-600 text-blue-600 rounded-md
              hover:bg-blue-50 transition"
            >
              Reject All
            </button>

            <button
              onClick={() => closeBanner("accepted")}
              className="px-6 py-2 text-sm font-semibold text-white rounded-md
              bg-gradient-to-r from-orange-500 to-red-500
              hover:from-orange-600 hover:to-red-600 transition"
            >
              Accept All Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
